import { Button, EmptyStates, Group, Stack, Text } from '@inflearn/ds-react-next';
import { useTranslation } from 'next-i18next';
import Link from 'next/link';
import { COURSE_URL } from '../../../../constants/urls';
import useClientAccountProfileQuery from '../../../../queries/useClientAccountProfileQuery';
import { EmptyStateForError } from '../../../common/EmptyStateForError';
import { MyVoucherGuideModalButton } from './MyVoucherGuideModal';
import VoucherItem from './VoucherItem';
import useVoucherEnrollmentVerificationsQuery from './queries/useVoucherEnrollmentVerificationsQuery';

export default function Vouchers() {
  const { t } = useTranslation();
  const { data: accountProfile } = useClientAccountProfileQuery();
  const { data, isError, isLoading } = useVoucherEnrollmentVerificationsQuery();

  const totalVouchers = data?.length || 0;

  if (isError) {
    return <EmptyStateForError />;
  }

  return (
    <Stack>
      <Group wrap="nowrap" justify="space-between" h={42} mb={8}>
        <Text size="sm" c="gray.7" fw={600}>
          {t('전체', { context: 'TOTAL' })}{' '}
          <Text component="span" size="sm" c="infgreen.7" fw={600} ml={2}>
            {totalVouchers}
          </Text>
        </Text>
        <MyVoucherGuideModalButton />
      </Group>
      {!isLoading && totalVouchers === 0 ? (
        <Stack justify="center" align="center" w="100%" h={320}>
          <EmptyStates
            image="NO_DATA"
            cta={
              <Button
                component={Link}
                size="xs"
                radius="md"
                variant="default"
                color="infgreen"
                href={COURSE_URL.COURSES({ types: 'ONLINE' })}
              >
                {t('강의 둘러보기')}
              </Button>
            }
            title={t('보유한 수강 확인증이 없어요')}
            body={t('강의를 듣고 수강 확인증을 받아보세요')}
          />
        </Stack>
      ) : (
        <Stack gap={10}>
          {data?.map((voucher) => (
            <VoucherItem key={voucher.id} realName={accountProfile?.realname} {...voucher} />
          ))}
        </Stack>
      )}
    </Stack>
  );
}
